import React from "react";
import Button from "./Button";

/**
 * OutlineButton - Outlined variant for secondary actions
 * 
 * Use for: Secondary actions that need more prominence than text links
 * 
 * @example
 * <OutlineButton onClick={handlePreview} variant="outline-blue">
 *   Preview
 * </OutlineButton>
 * <OutlineButton onClick={handleCancel} variant="outline-gray">
 *   Cancel
 * </OutlineButton>
 */
const OutlineButton = ({ variant = "outline-blue", ...props }) => {
  return <Button variant={variant} {...props} />;
};

export default OutlineButton;

